import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createApiClient } from '../../api/client';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: '#ccc',
  borderRadius: '8px',
  padding: '12px',
  marginBottom: '12px',
  fontFamily: 'inherit',
  fontSize: '14px',
};

const NewWitness = ({ API_URL }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR, setFullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;

  const [name, setName] = useState('');
  const [shortIntro, setShortIntro] = useState('');
  const [eyewitness, setEyewitness] = useState('');
  const [relevance, setRelevance] = useState('');
  const [relationWithComplainant, setRelationWithComplainant] = useState('');
  const [relationWithVictim, setRelationWithVictim] = useState('');
  const [relationWithAccused, setRelationWithAccused] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isDisabled = loading || !name.trim() || !shortIntro.trim() || !eyewitness || !relevance.trim();

  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      const response = await api.post(`/fir/witness`, {
        firId: fir.id,
        name: name.trim(),
        shortIntro: shortIntro.trim(),
        eyewitness,
        relevance: relevance.trim(),
        // relationWithComplainant: relationWithComplainant.trim(),
        relationWithVictim: relationWithVictim.trim(),
        // relationWithAccused: relationWithAccused.trim(),
      });
      setFullFIR(response.data);
      navigate('/m/fir/witnesses', { state: { fir: response.data } });
    } catch {
      setErrorMessage('Failed to add witness. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Add Witness</h2>

      <div style={{ marginBottom: '2px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ fontSize: '16px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Eyewitness</div>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={eyewitness === 'Yes'}
              onChange={() => setEyewitness(eyewitness === 'Yes' ? '' : 'Yes')}
              style={{ width: '16px', height: '16px', margin: 0, flexShrink: 0 }}
            />
            Yes
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={eyewitness === 'No'}
              onChange={() => setEyewitness(eyewitness === 'No' ? '' : 'No')}
              style={{ width: '16px', height: '16px', margin: 0, flexShrink: 0 }}
            />
            No
          </label>
        </div>
      </div>

      <input
        placeholder="Witness Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={inputStyle}
      />

      <textarea
        placeholder="Bio (Brief Intro)"
        value={shortIntro}
        onChange={(e) => setShortIntro(e.target.value)}
        rows={3}
        style={inputStyle}
      />

      <textarea
        placeholder="Relevance"
        value={relevance}
        onChange={(e) => setRelevance(e.target.value)}
        rows={3}
        style={inputStyle}
      />

      {/* <textarea
        placeholder="Relation with Complainant (optional)"
        value={relationWithComplainant}
        onChange={(e) => setRelationWithComplainant(e.target.value)}
        rows={2}
        style={inputStyle}
      /> */}

      <textarea
        placeholder="Relation with Victim (optional)"
        value={relationWithVictim}
        onChange={(e) => setRelationWithVictim(e.target.value)}
        rows={2}
        style={inputStyle}
      />

      {/* <textarea
        placeholder="Relation with Accused (optional)"
        value={relationWithAccused}
        onChange={(e) => setRelationWithAccused(e.target.value)}
        rows={2}
        style={inputStyle}
      /> */}

      <button onClick={handleSubmit} disabled={isDisabled} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Submit'}
      </button>

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewWitness;
